import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'
import axios from 'axios'

Vue.use(Vuex)
export default new Vuex.Store({
	state: {
		isLoggedIn: !!localStorage.getItem("token"),
		userRole: localStorage.getItem('userRole'),
		mainRole: localStorage.getItem('mainRole'),
		userName: localStorage.getItem('userName'),
		userData: {},
		counterData: {},
		notification: 0,
		authentication: false,
		districts: [],
		sideNavOpen: false

		// appLoading: false
	},
	mutations: {
		loginUser(state, item) {
			localStorage.setItem("token", item)
			state.isLoggedIn = item
			// if (state.userRole == 'admin') router.push('/admin')
			// else if (state.userRole == 'official') router.push('/officers')
		},

		logoutUser(state) {
			
			axios({
				method: "GET",
				url: "/user/logout",
				headers: {
					"x-auth-token": localStorage.getItem("token")
				}
			}).then(response => {
				if (response.data) {
					state.userData = {}
					state.userRole = null
					state.isLoggedIn = false
					state.notification = 0
					localStorage.removeItem("token");
					localStorage.removeItem("userRole");
					localStorage.removeItem("userName");
					localStorage.removeItem("mainRole");
					if (window.location.pathname != '/') {
						// router.push('/')	
						router.push('/login')

					}
				}
			})

			

		},
		userData(state, item) {
			state.userData = item
		},
		counterData(state, item) {
			state.counterData = item
		},
		changeNotification(state, item) {
			state.notification = item
		},
		authValue(state, item) {
			state.authentication = item
		},

		userRole(state, item) {
			state.userRole = item
			localStorage.setItem("userRole", item);
		},
		mainRole(state, item) {
			state.mainRole = item
			localStorage.setItem("mainRole", item);
		},
		userName(state, item) {
			state.userName = item
			localStorage.setItem("userName", item);
		},
		sessionOut(state) {
			localStorage.removeItem("token");
			state.isLoggedIn = false
			router.push('/Login')

		},
		setDistricts(state, list) {
			state.districts = list;
		},
		toggleSideNav(state) {
			state.sideNavOpen = !state.sideNavOpen;
		},
		setSideNav(state, val) {
			state.sideNavOpen = val;
		}
		
	},
	actions: {
		fetchDistricts({ commit, state }) {
			// Only fetch if it hasn't been fetched yet
			if (state.districts.length > 0) return;
			axios.get("/get/districts")
				.then(response => {
					if (response.data && response.data.status) {
						// Map the objects to an array of names
						const names = response.data.data.map(d => d.name);
						commit("setDistricts", names);
					}
				})
				.catch(err => {
					console.error("Error fetching districts:", err);
				});
		}
	}

})